import { Stack, Text } from '@etg/wings';
import { jsx as _jsx } from "react/jsx-runtime";
const BaggageSectionDescription = ({
  description,
  productName,
  travelerId
}) => {
  return /*#__PURE__*/_jsx(Stack, {
    children: /*#__PURE__*/_jsx(Text, {
      asHtml: true,
      "data-testid": `baggage-description-${productName}-${travelerId}`,
      children: description
    })
  });
};
export default BaggageSectionDescription;
//# sourceMappingURL=BaggageSectionDescription.js.map